// Crypto Wallets → Transactions → Deposits (SM-267, split out of the old
// /wallet-ops/orders tab bar). Inbound crypto deposits detected on-chain and
// credited as ⚡SPARK.
import { createFileRoute } from "@tanstack/react-router";
import {
  DepositsTable,
  OrderListPage,
  useAssetMap,
} from "@/components/wallet-ops/orders";
import { fetchCryptoDeposits } from "@/lib/wallet-queries";
import type { CryptoDepositOrder } from "@/lib/wallet-types";

export const Route = createFileRoute("/_app/wallet-ops/deposits")({
  component: DepositsPage,
});

function DepositsPage() {
  const assets = useAssetMap();
  return (
    <OrderListPage<CryptoDepositOrder>
      title="Deposits"
      description="Inbound crypto deposits detected on-chain and credited to the platform wallet. Hover any value for the raw wire form; click to copy."
      cardTitle="Deposit orders"
      tab="deposits"
      fetcher={fetchCryptoDeposits}
      renderTable={(items) => <DepositsTable items={items} assets={assets} />}
    />
  );
}
